import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
const Nosotros = () => {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-262">
      <Header data-id="element-263" />
      <main data-id="element-264">
        <About data-id="element-265" />
      </main>
      <Footer data-id="element-266" />
    </div>;
};
export default Nosotros;